import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { defaultTheme } from './themes';

var useThemeSC = function useThemeSC() {
  return useContext(ThemeContext);
};

export var useTheme = function useTheme(theme) {
  var scTheme = useThemeSC();

  if (theme) {
    return theme;
  }

  if (scTheme) {
    return scTheme;
  }

  return defaultTheme;
};